import { ModalConfig, useModal } from '@shape-ds/components';
import { CaseForm, CaseListItem } from 'queries/cases/types';
import { CaseDetails } from '../components/CaseDetails/CaseDetails';
import '../layout.style.scss';
import { usePreventLeaveModal } from 'hooks/usePreventEditLeave/usePreventEditLeave';
import { useCaseContext } from '../Cases.context';

const useCaseModal = () => {
  const { openModal, closeAll } = useModal();
  const { openLeaveModal } = usePreventLeaveModal();
  const { allActiveFilters, queryFilters } = useCaseContext();
  return {
    openCaseModal: (data?: Partial<CaseForm | CaseListItem>, config?: ModalConfig) => {
      openModal(
        <CaseDetails selectedRow={data} navigationState={{ allActiveFilters, queryFilters }} />,
        {
          ...config,
          className: 'cases cases-modal',
          PaperProps: { style: {}, className: 'cases-modal-paper' },
          shouldPreventLeave: () => {
            const url = new URL(window.location.href);
            return url.searchParams.has('edit');
          },
          onPreventLeave: () => {
            openLeaveModal(closeAll);
          },
        },
      );
    },
  };
};

export default useCaseModal;
